import React, { Component } from 'react';
import '../../styles/components/filter.scss';
import { Loader2 } from 'lucide-react';
import i18n from '../../i18n';

export default class FilterSection extends Component {
  render() {
    const { children, loading, onSearch, onClear } = this.props;

    return (
      <div className="filter-section">
        <div className="filters">{children}</div>
        <div className="filter-actions">
          <button className="clear-btn" onClick={onClear}>
            {i18n.t('clear')}
          </button>
          <button className="search-btn" disabled={loading} onClick={onSearch}>
            {loading ? (
              <span
                style={{
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <Loader2 className="animate-spin" size={16} /> {i18n.t('loading')}
              </span>
            ) : (
              i18n.t('search')
            )}
          </button>
        </div>
      </div>
    );
  }
}
